import { ReactElement } from 'react';

import { styledWithoutTheme as styled } from '../../../../styled';
import { Theme } from '../../../../theme/interface/detailed';
import { useTheme } from '../../../../theme/useTheme';
import { Interface } from '../interface';

export const NormalscreenIcon = styled((props: Interface): ReactElement => {
	const theme = useTheme();

	return (
		<div {...props}>
			<svg
				width={theme.videoCalls.icons.normalscreenIcon.width}
				height={theme.videoCalls.icons.normalscreenIcon.height}
				viewBox="0 0 24 24"
				fill={theme.videoCalls.icons.normalscreenIcon.backgroundColor}
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M19.6005 5.67847L15.7165 9.5625H18.375C18.8928 9.5625 19.3125 9.98218 19.3125 10.5C19.3125 11.0178 18.8928 11.4375 18.375 11.4375H14.8594C13.567 11.4375 12.5156 10.3861 12.5156 9.09375V5.57812C12.5156 5.0603 12.9353 4.64062 13.4531 4.64062C13.9709 4.64062 14.3906 5.0603 14.3906 5.57812V8.23663L18.2745 4.35278C18.6407 3.98657 19.2343 3.98657 19.6003 4.35278C19.9666 4.71881 19.9666 5.31244 19.6005 5.67847ZM10.5938 19.2188C11.1116 19.2188 11.5312 18.7991 11.5312 18.2812V14.7656C11.5312 13.4733 10.4799 12.4219 9.1875 12.4219H5.67188C5.15405 12.4219 4.73438 12.8416 4.73438 13.3594C4.73438 13.8772 5.15405 14.2969 5.67188 14.2969H8.33038L4.44635 18.1809C4.08032 18.5469 4.08032 19.1406 4.44635 19.5066C4.62946 19.6897 4.86951 19.7812 5.10938 19.7812C5.34924 19.7812 5.58929 19.6897 5.7724 19.5066L9.65625 15.6227V18.2812C9.65625 18.7991 10.0759 19.2188 10.5938 19.2188ZM23.0625 16.5C23.5803 16.5 24 16.0803 24 15.5625V3.75C24 1.68219 22.3178 0 20.25 0H3.75C1.68219 0 0 1.68219 0 3.75V20.25C0 22.3178 1.68219 24 3.75 24H20.25C22.3178 24 24 22.3178 24 20.25C24 19.7322 23.5803 19.3125 23.0625 19.3125C22.5447 19.3125 22.125 19.7322 22.125 20.25C22.125 21.2838 21.2838 22.125 20.25 22.125H3.75C2.71619 22.125 1.875 21.2838 1.875 20.25V3.75C1.875 2.71619 2.71619 1.875 3.75 1.875H20.25C21.2838 1.875 22.125 2.71619 22.125 3.75V15.5625C22.125 16.0803 22.5447 16.5 23.0625 16.5Z"
					fill={theme.videoCalls.icons.normalscreenIcon.fill}
				/>
			</svg>
		</div>
	);
})(({ theme }: { theme: Theme }) => theme.videoCalls.icons.normalscreenIcon);
